module.exports = __webpack_public_path__ + "img/203424910.3e01ae89.jpg";